import * as React from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Aux: React.FC<any> = (props) => props.children

export default Aux
